import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

import { AppErrorFallback } from '@/components/common/AppErrorFallback';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import { Toaster as SonnerToaster } from '@/components/ui/Sonner';
import { Toaster } from '@/components/ui/Toaster';
import { CurrencyProvider } from '@/contexts/CurrencyContext';
import { usePrintStyles } from '@/hooks/usePrintStyles';
import { useServiceWorkerCleanup } from '@/hooks/useServiceWorkerCleanup';
import Pages from '@/pages/index';

/**
 * Error fallback component for the main error boundary
 */
interface ErrorFallbackProps {
  error: Error | null;
  resetError: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error: _error,
  resetError: _resetError,
}) => <AppErrorFallback />;

function App() {
  // Initialize service worker cleanup
  useServiceWorkerCleanup();

  // Initialize print styles handling
  usePrintStyles();

  return (
    <HelmetProvider>
      <CurrencyProvider>
        <ErrorBoundary source="AppShell" fallbackRender={ErrorFallback}>
          <Pages />
        </ErrorBoundary>
        <Toaster />
        <SonnerToaster position="bottom-right" />
      </CurrencyProvider>
    </HelmetProvider>
  );
}

export default App;
